import { createSlotRecipe } from './runtime';

const pinInputConfig = {"name":"pinInput","slots":["root","label","input","control"],"defaultVariants":{"size":"md"},"variantMap":{"size":["2xl","lg","md","sm","xl","xs"]}}

export const pinInput = /* @__PURE__ */ createSlotRecipe(pinInputConfig)